











































import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

import { CategoryCoursesMap, Course, MobileGetter } from 'frontend/types';
import BriocheImageTag from 'frontend/components/BriocheImageTag.vue';

interface SplitCourseList {
  head: Course[];
  tail: Course[];
}

interface SplitCoursesByCategory {
  [category: string]: SplitCourseList;
}

const MOBILE_INITIAL_NUM_COURSES = 8;

@Component({
  components: {
    BriocheImageTag,
  },
  computed: {
    ...mapGetters('pageHeader', ['isMobile']),
    ...mapGetters('categorizedCourses', ['coursesByCategory']),
  },
})
export default class PaywallCoursesList extends Vue {
  private readonly isMobile!: MobileGetter;
  private readonly coursesByCategory!: CategoryCoursesMap;
  private showTailForCategory: { [key: string]: boolean } = {};

  private get splitCoursesByCategory(): SplitCoursesByCategory {
    const results: SplitCoursesByCategory = {};
    const doSplit = this.isMobile(this.$mq);
    // For mobile, only show the first 8 (MOBILE_INITIAL_NUM_COURSES) courses initially
    if (doSplit) {
      for (const [category, courses] of Object.entries(this.coursesByCategory)) {
        results[category] = {
          head: courses.slice(0, MOBILE_INITIAL_NUM_COURSES),
          tail: courses.slice(MOBILE_INITIAL_NUM_COURSES),
        };
      }
    } else {
      for (const [category, courses] of Object.entries(this.coursesByCategory)) {
        results[category] = {
          head: courses,
          tail: [],
        };
      }
    }
    return results;
  }

  private handleShowTail(category: string) {
    this.$set(this.showTailForCategory, category, true);
  }
}
